import fetcher from '../../utils/fetcher';
import { postPaymentDataResponse, PostPaymentDataProps } from '../../types/loanPayment';
import { PrepayRequestData } from '../../types/account';

export async function postPaymentData(props: PostPaymentDataProps):
  Promise<postPaymentDataResponse> {
  const { idNumber, captchaToken } = props;
  const res = await fetcher(
    `${process.env.REACT_APP_API_URL}/payment-data`,
    'POST',
    { idNumber, captchaToken },
    null,
  );
  return res;
}

export async function getPrepayRequest(token: string): Promise<PrepayRequestData[]> {
  const res = await fetcher(
    `${process.env.REACT_APP_API_URL}/client/prepay-request`,
    'GET',
    null,
    token,
  );
  return res.data;
}
